// Our own booking-ingest relay (Cloud Run, ahead-operations), which queues the
// event in Pub/Sub and hands it to the Activepieces "booking flow seems to be
// down" Slack alert. Replaces the old relay.app playbook. Deliberately NOT a
// Supabase edge function: this fires precisely when Supabase is the thing that
// is unreachable.
const WEBHOOK_URL =
  "https://booking-ingest-788583896796.europe-west6.run.app/api/v1/webhooks/Y4wPJUb1XZXDhovgRiPwV";

interface ErrorContext {
  language?: string;
  isDevelopment?: boolean;
  attemptCount?: number;
  [key: string]: unknown;
}

/**
 * Reports an error to the webhook for monitoring and alerting
 * Fire and forget - doesn't block on failure
 */
export const reportProductsFetchError = async (
  error: unknown,
  context: ErrorContext = {},
) => {
  try {
    const errorMessage = error instanceof Error ? error.message : String(error);
    const errorStack = error instanceof Error ? error.stack : undefined;

    const payload = {
      type: "PRODUCTS_FETCH_FAILURE",
      severity: "critical",
      error: {
        message: errorMessage,
        stack: errorStack,
      },
      context: {
        ...context,
        timestamp: new Date().toISOString(),
        userAgent: navigator.userAgent,
        url: window.location.href,
      },
    };

    // Fire and forget - don't block on this
    console.log("📤 Sending error report to webhook...", {
      url: WEBHOOK_URL,
      payload,
    });
    fetch(WEBHOOK_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    })
      .then((response) => {
        console.log(
          "✅ Error report sent to webhook. Status:",
          response.status,
        );
      })
      .catch((err) => {
        console.error("❌ Failed to report error to webhook:", err);
      });
  } catch (error) {
    console.error("Error in reportProductsFetchError:", error);
  }
};
